module.exports = __webpack_public_path__ + "static/media/pic2.49afee86.png";